module.exports = __webpack_public_path__ + "static/img/10001B_1_R_20200922_fit.95b99ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10001B_1_R_20200922_fit.png
// module id = /NOm
// module chunks = 0